export default __webpack_public_path__ + "static/media/template3.8b3117ab.svg";